import { render, staticRenderFns } from "./CopyTextButton.vue?vue&type=template&id=b1f11ab6&scoped=true"
import script from "./CopyTextButton.vue?vue&type=script&lang=js"
export * from "./CopyTextButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f11ab6",
  null
  
)

export default component.exports